export default [
  {
    title: "Info",
    route: "info",
    icon: "CodesandboxIcon",
    action: "read",
    resource: "Auth",
  },
  {
    title: "Banner",
    route: "home",
    icon: "ImageIcon",
    action: "read",
    resource: "Auth",
  },
  {
    title: "Category",
    route: "categories-list",
    icon: "PackageIcon",
    action: "read",
    resource: "Auth",
  },
  {
    title: "Product",
    route: "products-list",
    icon: "PackageIcon",
    action: "read",
    resource: "Auth",
  },
/*   {
    title: "我們的專業",
    route: "professionals-list",
    icon: "StarIcon"
  }, */
  {
    title: "設置(Setting)",
    route: "",
    icon: "SettingsIcon",
    children: [
      {
        title: "公司管理",
        route: "users-list",
        icon: "UserIcon",
        action: "read",
        resource: "users",
      },
    ],
  },
];
